<template>
  <div class="login">
    <div class="login__form-admin">
      <div v-if="firstForm" class="form-border">
        <h2 class="login__title">Bienvenido</h2>
        <p class="login__description">
          Crea tu cuenta y comienza el proceso de solicitud.
        </p>
        <div
          style="max-width: 40rem; margin-left: auto; margin-right: auto"
          class="form__group"
        >
          <label class="form__label">Correo electrónico:</label>
          <input type="email" v-model="username" class="form__input" />
          <validation-error :validation="$v.username" />
        </div>
        <div class="form__group">
          <div class="t1-checkbox">
            <input type="checkbox" v-model="agreeTerms" id="check-agree" />
            <!--<label for="check-agree"><span class="check-custom"></span>Estoy de acuerdo con los Términos de uso y Recopilación de datos</label>-->
          </div>
        </div>
        <div class="form__group">
          <!--<btn :type="btnStatus" @onClick="create" v-if="!loading" text="Crear" />-->
          <btn type="primary" @onClick="showTerms" text="Crear" />
        </div>
        <div class="form__group">
          <span class="create-account" @click="$refs.videohelp.toggleModal()"
            >¿Cómo realizo mi registro?</span
          >
        </div>
      </div>
      <div v-if="firstCodeSent" class="form-border">
        <h2 class="login__title">confirmar código</h2>
        <p class="login__description" style="text-align: left">
          Ingresa el código que te hemos enviado al correo para tu trámite de
          solicitud.
        </p>

        <div
          style="
            max-width: 40rem;
            margin-left: auto;
            margin-right: auto;
            max-width: 200px;
          "
          class="form__group"
        >
          <input
            type="text"
            maxlength="6"
            minlength="6"
            v-model="firstcode"
            class="form__input text-center"
          />
          <validation-error :validation="$v.firstcode" />
        </div>

        <div class="form__group">
          <btn type="primary" @onClick="processFirstCode" text="Confirmar" />
        </div>
      </div>
      <div v-if="createPasswordForm" class="form-border">
        <h2 class="login__title">CREAR CONTRASEÑA</h2>

        <div
          style="max-width: 40rem; margin-left: auto; margin-right: auto"
          class="form__group"
        >
          <label class="form__label">Contraseña:</label>
          <input
            :type="passwordVisible"
            v-model="password"
            class="form__input input-password"
          />
          <img
            @mousedown="togglePwdIcon(true)"
            @mouseup="togglePwdIcon(false)"
            @mouseleave="togglePwdIcon(false)"
            :src="'/img/icons/' + showPasswordIcon"
            class="show-password"
          />
          <validation-error :validation="$v.password" />
        </div>
        <div
          style="max-width: 40rem; margin-left: auto; margin-right: auto"
          class="form__group"
        >
          <label class="form__label">Confirmar contraseña:</label>
          <input
            :type="repeatPasswordVisible"
            v-model="repeatPassword"
            class="form__input input-password"
          />
          <img
            @mousedown="toggleRepeatPwdIcon(true)"
            @mouseup="toggleRepeatPwdIcon(false)"
            @mouseleave="toggleRepeatPwdIcon(false)"
            :src="'/img/icons/' + showRepeatPasswordIcon"
            class="show-password"
          />
          <validation-error :validation="$v.repeatPassword" />
        </div>
        <div class="form__group">
          <btn type="primary" @onClick="createPassword" text="Confirmar" />
        </div>
      </div>
    </div>
    <div class="login__bg"></div>
    <Popup ref="codesent" size="sm">
      <div class="text-center">
        <h1 class="text-center title-forgot-pwd mb-3">
          CÓDIGO ENVIADO A TU CORREO
        </h1>
        <p class="forgot-pwd-text">
          Ingresa a tu bandeja de entrada, abre el correo de solicitudes y en
          seguida copia el código que se te ha enviado.
        </p>
        <img
          src="/img/icons/sent-code.svg"
          width="200px"
          height="auto"
          alt=""
        />
        <div class="form__group mt-5">
          <btn
            type="primary-block"
            text="OK"
            @onClick="$refs.codesent.toggleModal()"
          />
        </div>
      </div>
    </Popup>
    <Popup ref="registercomplete" size="xs">
      <div class="text-center">
        <h1 class="text-center title-forgot-pwd mb-3">REGISTRO CONFIRMADO</h1>
        <p class="forgot-pwd-text" style="font-size: 19px">
          Registro de cuenta confirmada y creada correctamente.
        </p>
        <img src="/img/icons/ok.svg" width="200px" height="auto" alt="" />
        <p class="forgot-pwd-text mt-5 animated flash infinite">
          Ahora mismo le estamos redireccionando...
        </p>
      </div>
    </Popup>
    <Popup ref="errorPop" size="xs">
      <div class="text-center">
        <h1 class="text-center title-forgot-pwd mb-3">
          {{ errorDescription }}
        </h1>
        <p class="forgot-pwd-text" style="font-size: 19px">{{ errorTitle }}</p>
        <img src="/img/icons/error.svg" width="150px" height="auto" alt="" />
        <div class="form__group mt-5">
          <btn
            type="primary-block"
            text="Cerrar"
            @onClick="$refs.errorPop.toggleModal()"
          />
        </div>
      </div>
    </Popup>

    <Popup ref="termsPop" size="md">
      <div class="text-center">
        <h4 class="login__title mb-4 custom_size">
          TÉRMINOS DE USO Y RECOPILACIÓN DE DATOS
        </h4>

        <div class="scroll-text">
          <p>
            “Club de Golf Tres Marías”, S.A. de C.V., con domicilio en Avenida
            Tres Marías, Número 600 Interior A-302, Colonia Tres Marías,
            Municipio de Morelia, Michoacán, México, C.P. 58254, utilizará sus
            datos personales recabados, para analizar la factibilidad de su
            admisión como socio del Condominio y Club de Golf “Tres Marías”; la
            cual será utilizada, en forma enunciativa pero sin limitar, para la
            integración del expediente administrativo e informar a los socios y
            condóminos de su solicitud. Reservándose el derecho de poner a
            disposición de los socios y condóminos su información, para indagar
            la veracidad de su información, así como a empresas especializadas
            en investigación de personas relacionadas con lavado de dinero,
            cumplimiento de obligaciones fiscales, fraude, narcotráfico,
            terrorismo y otros delitos. Para mayor información acerca del
            tratamiento y de los derechos que puede hacer valer, usted puede
            acceder al aviso de privacidad integral a través de
            <b>https://solicitudes.kiritek.com/privacidad</b>.
          </p>
          <p>
            “Club de Golf Tres Marías”, S.A. de C.V., se reserva el derecho de
            no revelar o mencionar las causas, motivos o razónes por negar la
            admisión de cualquier solicitante.
          </p>
          <mdb-row>
            <mdb-col md="12" sm="6">
              <div class="form__group" style="margin-bottom: 20px">
                <div class="t1-checkbox">
                  <input
                    type="checkbox"
                    v-model="agreeTerms"
                    id="check-agree"
                  />
                  <label for="check-agree" class="custom_title_a"
                    ><span class="check-custom"></span>Estoy de acuerdo con los
                    Términos de uso y Recopilación de datos</label
                  >
                </div>
              </div>
            </mdb-col>
          </mdb-row>

          <mdb-row class="justify-content-center align-items-center">
            <mdb-col md="3">
              <div class="form__group" style="margin-bottom: 10px">
                <btn
                  type="ghost"
                  text="Cancelar"
                  @onClick="$refs.termsPop.toggleModal()"
                />
              </div>
            </mdb-col>

            <mdb-col md="3">
              <div class="form__group" style="margin-bottom: 10px">
                <btn
                  :type="btnStatus"
                  @onClick="create"
                  v-if="!loading"
                  text="Continuar"
                />
              </div>
            </mdb-col>
          </mdb-row>
        </div>
      </div>
    </Popup>

    <Popup ref="videohelp" size="md-mod">
      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half">
        <iframe
          class="embed-responsive-item"
          src="https://kiritek-web-documents.s3-us-west-2.amazonaws.com/solicitudes/videos-pasos/SistemaSolicitudes-0-RegistroAcceso.mp4"
          allowfullscreen
          autoplay
        ></iframe>
      </div>
    </Popup>

    <Footer :absolute="true" />
  </div>
</template>
<script>
import Btn from "../core/Button";

import {mdbRow, mdbCol } from "mdbvue";
import {
  required,
  email,
  minLength,
  sameAs,
} from "vuelidate/lib/validators";
import ValidationError from "./misc/ValidationError";
import { mapActions, mapState } from "vuex";
import Popup from "../core/Popup";
import { hasNumeric, hasUppercase } from "../../validations";
import Footer from "../core/Footer";
import Swal from "sweetalert2";

export default {
  name: "Register",
  components: {
    mdbRow,
    mdbCol,
    Btn,
    ValidationError,
    Popup,
    Footer,
  },
  data() {
    return {
      username: "",
      password: "",
      repeatPassword: "",
      passwordVisible: "password",
      repeatPasswordVisible: "password",
      agreeTerms: false,
      firstcode: "",
      secondcode: "",
      firstForm: true,
      firstCodeSent: false,
      createPasswordForm: false,
      loading: false,
      errorTitle: "",
      errorDescription: "",
    };
  },
  validations: {
    username: {
      email,
      required,
    },
    firstcode: {
      required,
    },
    password: {
      required,
      minLength: minLength(8),
      hasUppercase,
      hasNumeric,
    },
    repeatPassword: {
      sameAs: sameAs("password"),
    },
  },
  computed: {
    ...mapState({ authenticated: (state) => state.auth.authenticated }),
    showPasswordIcon() {
      let icon = "";
      if (this.passwordVisible == "password") {
        icon = "password-hidden.svg";
      } else {
        icon = "password-visible.svg";
      }
      return icon;
    },
    showRepeatPasswordIcon() {
      let icon = "";
      if (this.repeatPasswordVisible == "password") {
        icon = "password-hidden.svg";
      } else {
        icon = "password-visible.svg";
      }
      return icon;
    },
    btnStatus() {
      return this.agreeTerms ? "primary" : "disabled";
    },
  },
  methods: {
    ...mapActions([
      "createApplicant",
      "validateEmail",
      "confirmFirstCode",
      "createNewPassword",
      "authenticate",
    ]),
    togglePwdIcon(icon) {
      if (icon) {
        this.passwordVisible = "text";
      } else {
        this.passwordVisible = "password";
      }
    },
    toggleRepeatPwdIcon(icon) {
      if (icon) {
        this.repeatPasswordVisible = "text";
      } else {
        this.repeatPasswordVisible = "password";
      }
    },
    clear() {
      this.username = "";
      this.agreeTerms = false;
    },
    async showTerms() {
      this.$v.$touch();
      try {
        if (this.$v.username.email && this.$v.username.required) {

          this.$refs.termsPop.toggleModal();
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        //console.log("e", e);
      }
    },
    async create() {
      this.$v.$touch();
      if (this.$v.username.email && this.$v.username.required) {
        try {
          // let response = await this.validateEmail(this.username);
          // if(response.data.valid){
          try {
            let responseAp = await this.createApplicant({
              username: this.username,
            });
            if (responseAp.data.status == 201) {
              this.firstForm = false;
              this.firstCodeSent = true;
              this.$refs.termsPop.toggleModal();
              this.$refs.codesent.toggleModal();
            }
            this.$v.$reset();
          } catch (e) {
            if (e.response.data.errorDetails) {
              this.errorTitle = e.response.data.errorDetails;
              this.errorDescription = e.response.data.message;
            } else {
              this.errorTitle = "Ocurrió un error desconocido";
              this.errorDescription =
                "Por favor contacte al administrador del sistema";
            }
            this.$refs.termsPop.toggleModal();
            this.$refs.errorPop.toggleModal();
          }
          // }
        } catch (e) {
          let emessage = "";
          if (e.response.data.errorDetails) {
            emessage = e.response.data.errorDetails;
          }
          this.$notify.error({
            message: emessage,
            position: "top right",
            timeOut: 5000,
          });
        }
      }
    },
    async processFirstCode() {
      this.$v.$touch();
      if (this.$v.firstcode.required) {
        try {
          let response = await this.confirmFirstCode(this.firstcode);
          if (response.status == 200) {
            this.$v.$reset();
            this.secondcode = response.data.data;
            this.firstCodeSent = false;
            this.createPasswordForm = true;
          }
        } catch (e) {
          if (e.response.data.status == 500) {
            this.$notify.error({
              message: e.response.data.message,
              position: "top right",
              timeOut: 5000,
            });
            this.firstForm = false;
            this.firstCodeSent = true;
            this.firstcode = "";
          }

          if (e.response.data.errorDetails) {
            this.$notify.error({
              message: e.response.data.errorDetails,
              position: "top right",
              timeOut: 5000,
            });
          }
        }
      }
    },
    async createPassword() {
      this.$v.$touch();
      if (this.$v.password.required && this.$v.repeatPassword.sameAs) {
        try {
          let data = {};
          data.secondcode = this.secondcode;
          data.password = this.password;
          let response = await this.createNewPassword(data);
          if (response.data.status == 200) {
            await this.authenticate({
              email: this.username,
              password: this.password,
            });
            if (this.authenticated) {
              this.$refs.registercomplete.toggleModal();
              setTimeout(() => {
                this.$router.push("/home");
                this.$notify.success({
                  message:
                    "Bienvenido al sistema de solicitudes de club de golf",
                  position: "bottom right",
                  timeOut: 5000,
                });
              }, 3000);
            }
          }
        } catch (e) {
          if (
            e &&
            e.response &&
            e.response.data &&
            e.response.data.status === 400 &&
            e.response.data.message
          ) {
            await Swal.fire({
              title:
                "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans,serif; color: #dc7134'>" +
                "¡EL TIEMPO PARA CREAR TU CONTRASEÑA HA EXPIRADO!" +
                "</span>",
              html:
                "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans,serif' color: #828282'>" +
                `<p>Te hemos enviado un nuevo código de confirmación para completar tu registro, revisa tu bandeja de entrada.</p>` +
                "<p style='padding-top: 1rem;'> <img src='/img/icons/sent-code.svg' width='200px' height='auto'  alt='Alerta'/> </p>" +
                "</div>",
              allowOutsideClick: false,
              width: "50rem",
              padding: "2rem",
              confirmButtonText: "IR A CONFIRMACIÓN DE CÓDIGO",
              confirmButtonColor: "#dc7134",
              customClass: {
                confirmButton: "t1-btn t1-btn--primary-block",
              },
              onClose: () => {
                this.password = "";
                this.repeatPassword = "";
                this.firstCodeSent = true;
                this.createPasswordForm = false;
                this.firstcode = "";
              },
            });
          } else if (e.response.data.status == 500) {
            this.$notify.error({
              message: e.response.data.message,
              position: "top right",
              timeOut: 5000,
            });
            this.firstForm = false;
            this.firstCodeSent = true;
            this.firstcode = "";
          } else {
            this.$notify.error({
              message: "Se ha producido un error, vuelva a intentarlo",
              position: "top right",
              timeOut: 5000,
            });
          }
        }
      }
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
.input-password {
  display: inline;
}

.show-password {
  position: absolute;
  padding-top: 1.1rem;
  padding-left: 0.5rem;
  display: inline;
}

.form-border {
  border: 1px solid #285f46;
  padding: 100px 50px;
  margin: 0px 100px;
  border-radius: 10px;
}

$medium-grey: #828282;

.input-password {
  display: inline;
}

.btn-inline {
  display: inline;
  &:not(:last-child) {
    padding-right: 1.5rem;
  }
}

.show-password {
  position: absolute;
  margin-top: auto;
  margin-bottom: auto;
  padding-top: 1.1rem;
  padding-left: 0.5rem;
  display: inline;
}

.title-forgot-pwd {
  text-transform: uppercase;
  color: $medium-grey;
  font-weight: 400;
  font-family: Josefin Sans;
  font-size: 2.7rem;
}

.forgot-pwd-text {
  color: $medium-grey;
  font-size: 1.4rem;
  padding: 0.5rem 0.5rem;
  text-align: center;
}

.custom_size {
  font-size: 18px !important;
}
.custom_title_a {
  font-size: 14px !important;
  color: #285f46 !important;
  font-weight: 600 !important;
}

.scroll-text {
  width: 100%;
  height: 420px;
  position: relative;
  overflow: scroll;
}

.scroll-text p {
  width: 100%;
  height: auto;
  color: #000;
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 30px;
  text-align: justify;
  font-weight: 400;
}

@media (max-width: 1500px) {
  .form-border {
    margin: 0 70px;
    padding: 50px 50px;
  }
}

@media (max-width: 991px) {
  .form-border {
    margin: 0px 0px;
    padding: 50px 25px;
  }
}
</style>
